import { memo } from 'react';
import { StatusMessage, Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { SearchX, Store, Send } from 'lucide-react';

/**
 * No-results empty state for the Already Integrated in-place search (CT-4162).
 * Offers two escape routes: search the Marketplace (carries the query over) and
 * request the integration (prefilled with the query → CT-4175 modal).
 */
function AlreadyIntegratedEmptyState({ query, onSearchMarketplace, onRequest }) {
  const { t } = useTranslation('admin-studio');

  return (
    <div className="flex flex-col items-center gap-4 py-8">
      <StatusMessage
        icon={SearchX}
        title={t('integrations.alreadyIntegrated.search.noResultsTitle')}
        subtitle={t('integrations.alreadyIntegrated.search.noResultsSubtitle', { query })}
      />
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button variant="secondary" size="sm" leftIcon={Store} onClick={onSearchMarketplace}>
          {t('integrations.alreadyIntegrated.search.searchMarketplace')}
        </Button>
        <Button variant="tertiary" size="sm" leftIcon={Send} onClick={onRequest}>
          {t('integrations.alreadyIntegrated.search.requestQuery', { query })}
        </Button>
      </div>
    </div>
  );
}

export default memo(AlreadyIntegratedEmptyState);
